import React, { ReactNode } from 'react';
import { TFunction, withTranslation, WithTranslation } from 'next-i18next';

import { FieldLegend, RequiredFlag } from './styles';

interface LegendProps extends WithTranslation {
    t: TFunction;
    size: 'default' | 'large';
    addRequiredFlag?: boolean;
    children?: ReactNode;
    className?: string;
    id?: string;
}

const Legend = ({ t, size = 'default', addRequiredFlag, children, className, id }: LegendProps) => {
    return (
        <FieldLegend size={size} className={className} id={id}>
            {children}
            {addRequiredFlag ? (
                <RequiredFlag> ({t('required')})</RequiredFlag>
            ) : (
                <RequiredFlag> ({t('optional')})</RequiredFlag>
            )}
        </FieldLegend>
    );
};

export default withTranslation('common')(Legend);
